export enum HeaderStatusEnum {
  BEFORE_LOGGED_IN,
  AFTER_LOGGED_IN,
}
